import { roundDoubleNumbers } from '../../helpers/currency';
import { AppBarTypography } from './shoppingCartStyles';
import { useAppSelector } from '../../redux/hooks';
import { CartBarBadgeIcon } from './cartBarBadgeIcon';
import { RootState } from '../../redux/store';

export function CartBarBadgeItem() {
  const price = useAppSelector((state: RootState) => state.shoppingCartState.totalPrice);

  return (
    <>
      <CartBarBadgeIcon />
      <AppBarTypography> {roundDoubleNumbers(price)} €</AppBarTypography>
    </>
  );
}
